import React, { useState } from "react";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import ReCAPTCHA from "react-google-recaptcha";
import Select from "react-select";
import Loader from "@ADC/components/Views/Loader";

const Step3 = ({
  handleSubmit,
  handleChange,
  loading,
  values,
  setStep,
  step,
}) => {
  const [token, setToken] = useState("");
  const siteKey = "6LdTYnknAAAAAEUBgCdOjFC3jEBb6iOldVjBdMCt";
  const options = [
    { value: "credit card(s)", label: "Credit Card(s)" },
    { value: "personal loan(s)", label: "Personal Loan(s)" },
    { value: "hospital bills", label: "Hospital Bills" },
    { value: "vehicle loans", label: "Vehicle Loans" },
    { value: "Other", label: "Other" },
  ];

  const handleCaptchaChange = (reCaptchaToken) => setToken(reCaptchaToken);

  return (
    <div className="w-auto justify-center items-center mt-8 md:px-8">
      <p className="text-green-800 text-center text-3xl font-bold mb-6 mt-5">
        Contact Information
      </p>
      <form
        className="mx-auto max-w-xl"
        onSubmit={(e) => {
          if (token) {
            handleSubmit(e);
          } else {
            e.preventDefault();
            alert("Please verify that you are not a robot.");
          }
        }}
      >
        <div className="grid grid-cols-1 gap-x-4 gap-y-5 sm:grid-cols-2">
          <div className="relative">
            <label
              htmlFor="first-name"
              className="text-sm font-bold text-green-800 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              First Name*
            </label>
            <input
              type="text"
              name="first_name"
              id="first_name"
              autoComplete="given-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-green-800 border-2"
              value={values.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="last-name"
              className="text-sm font-bold text-green-800 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Last Name*
            </label>
            <input
              type="text"
              name="last_name"
              id="last_name"
              required
              autoComplete="family-name"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-green-800 border-2"
              onChange={handleChange}
              value={values.last_name}
            />
          </div>
          <div className="relative">
            <label
              htmlFor="email"
              className="text-sm font-bold text-green-800 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Email Address*
            </label>
            <input
              type="email"
              name="email"
              id="email"
              autoComplete="email"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-green-800 border-2"
              onChange={handleChange}
              value={values.email}
              required
            />
          </div>
          <div className="relative">
            <label
              htmlFor="phone"
              className="text-sm font-bold text-green-800 absolute left-4 bg-white"
              style={{ top: "-10px" }}
            >
              Phone Number*
            </label>
            <input
              type="number"
              name="phone"
              id="phone"
              autoComplete="tel"
              className="w-full px-3.5 py-2 text-gray-800 sm:text-sm sm:leading-6 border-green-800 border-2"
              onChange={handleChange}
              value={values.phone}
              required
            />
          </div>
          <div className="sm:col-span-2">
            <Select
              placeholder="Type of debt…."
              classNamePrefix="select"
              className="w-full text-start"
              options={options}
              name="colors"
              classNames={{
                control: (state) =>
                  state.isFocused ? "border-green-800" : "border-green-800",
              }}
              onChange={(values) => {
                const e = {
                  target: {
                    name: "options",
                    value: `"${values.map((option) => option.value)}"`,
                  },
                };
                handleChange(e);
              }}
              isMulti
            />
          </div>
          <div className="sm:col-span-2">
            <div className="mt-2.5">
              <ReCAPTCHA onChange={handleCaptchaChange} sitekey={siteKey} />
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-sm text-gray-900">
            By clicking "Submit" you agree to allow Affordable Debt
            Consolidation to contact you by phone, SMS, or email. We never sell
            your information.
          </p>
          <div className="my-4 flex items-center justify-center">
            <button
              className="bg-white text-green-800 font-bold py-2 rounded-full transition border-green-800 border-4 mr-3 w-40"
              type="button"
              onClick={() => setStep(step - 1)}
            >
              <NavigateBeforeIcon /> Back
            </button>
            <button
              className="bg-green-800 text-white font-bold py-3 rounded-full transition hover:bg-green-800 w-40"
              disabled={loading}
              type="submit"
            >
              {loading ? (
                <Loader colorClassName="fill-custom-primary" spacing={false} />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Step3;
